class ImageOverlayModel {
  constructor(data, selectedPhotoID, isLoopy) {

    this.selected = null;
    this.totalImages = 0;
    this.values = [];

    const { Results } = data;

    this.map = Results.reduce((acc, review) => {
      review.Photos.forEach((photo) => {
        acc[photo.Id] = { value: { review, photo } };
        this.values.push(acc[photo.Id]);
      });
      return acc;
    }, {});

    const tail = this.values.reduce((acc, node, index) => {
      const currentNode = node;
      currentNode.previous = acc;
      currentNode.value.i = index;
      return currentNode;
    }, null);

    const head = this.values.reduceRight((acc, node, index) => {
      const currentNode = node;
      currentNode.next = acc;
      return currentNode;
    });

    if (isLoopy === true) {
      tail.next = head;
      head.previous = tail;
    }

    this.totalImages = this.values.length;

    if (!this.selectImageByID(selectedPhotoID)) {
      this.selectImageByID(this.values[0].value.photo.Id);
    }

  }

  selectImageByID(id) {
    if (this.map[id]) {
      this.selected = this.map[id];
      return this.selected.value;
    }

    return null;
  }

  selectImageByNode(node) {
    this.selected = node;
    return this.selected.value;
  }

  selectNextImage() {
    return this.selected.next
      ? this.selectImageByNode(this.selected.next)
      : null;
  }

  selectPreviousImage() {
    return this.selected.previous
      ? this.selectImageByNode(this.selected.previous)
      : null;
  }

  hasNextImage() {
    return !!this.selected.next;
  }

  hasPreviousImage() {
    return !!this.selected.previous;
  }

}

export default ImageOverlayModel;
